module.exports = __webpack_public_path__ + "img/cancun-bay-beach.707eddfe.jpg";